/** Chart mode to use */
export enum ChartModeEnum {
  /** Group by day */
  DAY = 'DAY',
  /** Group by week */
  WEEK = 'WEEK',
  /** Group by month */
  MONTH = 'MONTH',
  /** Group by quarter */
  QUARTER = 'QUARTER',
}
